{
    "ControlsAgentButtonTitle": "Afficher toutes les commandes disponibles pour l'agent",
    "ControlsDeviceButtonTitle": "Afficher toutes les commandes disponibles pour l'appareil",
    "NAME": "StaticAgentControls"
}